import { connect } from 'react-redux';
import { getEmployeeFormValues } from 'src/reducers/employees/employees';
import selector from 'src/utils/Utils';
import BanksSection from '../components/BanksSection';

const mapStateToProps = state => ({
  lastNameKana: selector(getEmployeeFormValues(state), 'employee', 'lastNameKana'),
  firstNameKana: selector(getEmployeeFormValues(state), 'employee', 'firstNameKana')
});
export default connect(mapStateToProps)(BanksSection);
